export const ShopFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm8.822 12.588L8.478 8H7l4.464 8.797h.718l.754-.002zm4.536-5.3.643-1.27-1.526.002-.633 1.267z"
      clipRule="evenodd"
    ></path>
  </svg>
);
